'use client';

import { useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

interface OAuthFallbackProviderProps {
  children: React.ReactNode;
}

/**
 * Provider that handles OAuth users who might not have backend API access
 * This prevents unnecessary redirects and provides a better UX for OAuth users
 */
export function OAuthFallbackProvider({ children }: OAuthFallbackProviderProps) {
  const { data: session, status } = useSession();
  const router = useRouter();

  useEffect(() => {
    // Only run for authenticated OAuth users
    if (status === 'authenticated' && session?.user) {
      const isOAuthUser = 
        (session.user as any)?.provider === 'google' || 
        session.user?.id?.startsWith('google_') ||
        session.accessToken?.startsWith('eyJ'); // JWT token format

      if (isOAuthUser) {
        console.log('OAuth user detected, setting up fallback authentication');
        
        // Store a flag to indicate this is an OAuth user
        if (typeof window !== 'undefined') {
          localStorage.setItem('isOAuthUser', 'true');
          localStorage.setItem('oauthProvider', (session.user as any)?.provider || 'google');
        }
      }
    }
  }, [session, status]);

  return <>{children}</>;
} 